export default __webpack_public_path__ + "static/media/warningIcon.27a2085d.svg";